import Analitycs from './analytics';

function InitHandlers () {
    const btnBackArrow = document.getElementById('btnBackArrow');
    const btnBackText = document.getElementById('btnBackText');
    const mainLogoHeader = document.getElementById('mainLogoHeader');
    const scrollButton = document.getElementById('scroll-incentive');

    btnBackArrow?.addEventListener('click', () => {
        Analitycs.buttonsTracker("flecha_volver");
    });

    btnBackText?.addEventListener('click', () => {
        Analitycs.buttonsTracker('btn_volver');
    });

    mainLogoHeader?.addEventListener('click', () => {
        Analitycs.buttonsTracker('logo_header');
    });

    scrollButton?.addEventListener('click', () => {
        Analitycs.buttonsTracker('flecha_scroll')
    }, { once:true })
}

module.exports = {
    init: () => {
        InitHandlers();
    },
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/buttonTracker.js